import Spacer from '../Spacer/Spacer.jsx';
import {getBaseImagePath} from "../../../../ui/catalog/Utils";

const ButtonDouble = (props) => {
	const data = Array.isArray(props.params?.data) ? props.params.data : [];
	return (
		<>
			<div className='landing-doubleBtn'>
				{data.map((item, index) => (
					<div key={index} className='mblock text-center'>
						<a href={item.url}>
							<img
								className="landing-img-btn"
								src={getBaseImagePath() + item.img}
								alt={item.img}
							/>
						</a>
						<Spacer />
					</div>
				))}
			</div>
		</>
	);
};

export default ButtonDouble;